import React from 'react';
import * as Icon from 'react-feather';
const navigationConfig = [
    {
        id: 'dashboard',
        title: 'Home',
        type: 'item',
        icon: <Icon.Home size={20} />,
        permissions: ['ADMIN', 'AFFILIATE', 'ACCOUNTANT'],
        navLink: '/dashboard'
    },
    {
        id: "users",
        title: "Tài khoản Admin",
        type: "item",
        icon: <Icon.User size={20} />,
        permissions: ["ADMIN"],
        navLink: "/user/list"
    },
    {
        id: "insurance",
        title: "Đơn hàng",
        type: "item",
        icon: <Icon.ShoppingCart size={20} />,
        permissions: ['ADMIN', 'AFFILIATE', 'ACCOUNTANT'],
        navLink: '/insurance/list',
    },
    {
        id: "merchant",
        title: "Merchant",
        type: "item",
        icon: <Icon.Award size={20} />,
        permissions: ['ADMIN'],
        navLink: '/merchant/list',

    },
    {
        id: "user",
        title: "User",
        type: "item",
        icon: <Icon.Award size={20} />,
        permissions: ['ADMIN'],
        navLink: '/users/list',

    },
    {
        id: "campaign",
        title: "Campaign",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/campaign/list',

    },
    {
        id: "prductline",
        title: "Dòng sản phẩm",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/productline/list',

    },
    {
        id: "affiliate",
        title: "Affiliate link",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/affiliate/list',

    },
    {
        id: "comission",
        title: "Merchant Comission",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/comission-merchant/list',

    },
    {
        id: "referral",
        title: "Referral Comission",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/referral-merchant/list',

    },
    {
        id: "affiliate-comiision",
        title: "Affiliate Comission",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/referral-affiliate/list',

    },
    {
        id: "contact",
        title: "Liên hệ tư vấn",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/contact/list',

    },
    {
        id: "bonus-comiision",
        title: "Bonus Affiliate",
        type: "item",
        icon: <Icon.Briefcase size={20}/>,
        permissions: ['ADMIN'],
        navLink: '/bonus-affiliate/list',
    },
    {
        id: "Provider",
        title: "Provider",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/provider/list',

    },
    {
        id: "bonus-merchant",
        title: "Bonus Merchant",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/bonus-merchant/list',
    },
    {
        id: "bonus-referral",
        title: "Bonus Referral",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/bonus-referral/list',
    },
    {
        id: "question",
        title: "Question",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/question/list',
    },
    {
        id: "product",
        title: "Product",
        type: "item",
        icon: <Icon.Briefcase size={20} />,
        permissions: ['ADMIN'],
        navLink: '/product/list',
    },
];

export default navigationConfig;
